export default {"src":"/_next/static/image/public/images/man.83fe99f4ed85e634314350aecba55bce.svg","height":58,"width":58};